__turbopack_context__.v({
  "counterButton": "_35g9gW_counterButton",
  "counterButtonMin": "_35g9gW_counterButtonMin",
});
